import type { ComponentDefinition } from '../factory';

export const miniGaugeDefinition = {
  base: 'items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5',
  slots: {
    label: {
      base: 'text-muted-foreground text-xs',
    },
  },
} satisfies ComponentDefinition;
